// Selecting a program drops the previous program's items first, so charts never render
// stale data, and ignores late responses once another program has been selected.
export const focusProgram = async (
    program,
    { fetchItems, setSelected, setItems, setLoading, isStale, onError }
) => {
    setSelected(program);
    setItems([]);
    setLoading(true);
    try {
        const { data } = await fetchItems(program._id);
        if (isStale()) return;
        setItems([...data].sort((a, b) => a.order - b.order));
        setLoading(false);
    } catch (error) {
        if (isStale()) return;
        onError(error);
        setLoading(false);
    }
};

// Post-mutation refresh: the same staleness guard as focusProgram, so a slow response for
// the former program cannot overwrite the items of the program focused since.
export const refreshProgramItems = async (programId, { fetchItems, setItems, isStale }) => {
    const { data } = await fetchItems(programId);
    if (isStale()) return;
    setItems([...data].sort((a, b) => a.order - b.order));
};
